import React, { FC, useState } from 'react';
import { useQuery } from 'react-query';
import { Fade, Grid, Box, FormControl, MenuItem } from '@mui/material';
import { Modal, Loader, ModalSaveSection, SMBSelect } from '../../../components';
import { useSnackbar } from 'notistack';
import { IDropdownResponse } from '../../../models';
import { getUploadDocumentTypes, uploadFileManagementDocument } from '../../../fetch';
import { FileManagementUpload } from './file-management-upload';

interface IAddFileModal {
  open: boolean;
  onClose: () => void;
}
export const AddFileModal: FC<IAddFileModal> = ({ open, onClose }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState<number | string>('');
  const [fileData, setFileData] = useState<any>();
  const { enqueueSnackbar } = useSnackbar();

  const { isLoading: isLoadingDocumentTypes, data: documentTypes } = useQuery<
    IDropdownResponse[],
    Error
  >(['document-types'], async () => await getUploadDocumentTypes(), {
    notifyOnChangeProps: 'tracked',
    enabled: open,
    staleTime: 0
  });

  const handleClose = () => {
    setSelectedDocumentType('');
    setFileData(null);
    onClose();
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const formData = new FormData();
      formData.append('Document', fileData);

      await uploadFileManagementDocument(selectedDocumentType, formData);
      setIsSaving(false);
      enqueueSnackbar('Success, file saved!', {
        variant: 'success'
      });
      handleClose();
    } catch (error) {
      enqueueSnackbar(error?.Detail ?? `Error adding file, please try again.`, {
        variant: 'error'
      });
      setIsSaving(false);
    }
  };

  return (
    <>
      <Modal
        title="Add File"
        open={open}
        onClose={() => {
          handleClose();
        }}
        maxWidth="xs"
      >
        {isSaving && <Loader type="overlay" position="centered" />}
        <Fade in={open}>
          <Box mt={1}>
            <Grid container>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" size="small" required>
                  <SMBSelect
                    name="category"
                    label="Category"
                    disabled={isLoadingDocumentTypes}
                    id="category"
                    value={selectedDocumentType}
                    variant="outlined"
                    onChange={({ target: { value } }) => {
                      setSelectedDocumentType(value);
                    }}
                  >
                    {documentTypes &&
                      documentTypes.map((documentType, index) => {
                        return (
                          <MenuItem key={`${index}`} value={documentType.value}>
                            {documentType.description}
                          </MenuItem>
                        );
                      })}
                  </SMBSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <FileManagementUpload
                      setFileData={value => setFileData(value)}
                      uploadText={'Upload File'}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <ModalSaveSection
              isSaveDisabled={!selectedDocumentType || !fileData}
              handleCancel={() => {
                handleClose();
              }}
              handleSave={() => {
                handleSave();
              }}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
